import React from 'react'
import Input from 'components/Input'
import { withTranslation } from 'react-i18next'
import GooglePlaces from 'components/GooglePlaces'
import { Box } from '@mui/material'

export default withTranslation()(function AddBranch({ t }) {
  // const [LocationUrl, setLocationUrl] = useState('')
  const fields = [
    {
      name: 'name',
      label: `${t('settings.branch.table.header.name')}`,
      placeholder: `${t('settings.branch.form.name.placeholder')}`,
    },
    {
      name: 'location',
      label: `${t('settings.branch.form.location.label')}`,
      placeholder: `${t('settings.branch.form.location.placeholder')}`
    },
    {
      name: 'google_map_url',
      label: `${t('settings.branch.form.location.label')}`,
      placeholder: `${t('settings.branch.form.location.placeholder')}`,
      type: 'location'
    },
    {
      name: 'address',
      label: `${t('settings.branch.form.address.label')}`,
      placeholder: `${t('settings.branch.form.address.placeholder')}`,
    },
    [
      {
        name: 'opens_at',
        label: `${t('settings.branch.form.opens_at.label')}`,
        type: 'time',
      },
      {
        name: 'closes_at',
        label: `${t('settings.branch.form.closes_at.label')}`,
        type: 'time',
      }
    ]
  ]

  const getUrl = (data) => {
    // setLocationUrl(data)
  }
  return (
    <Box component={'div'} sx={{ overflowY: 'auto', height: 'auto' }} >
      {
        fields.map((field, index) => {
          return (
            <React.Fragment key={index.toString()}>
              {
                field.length ? (
                  <div className="grid md:grid-cols-2 gap-5" key={field.name}>
                    {
                      field.map(singleField => {
                        return (
                          <Input
                            name={singleField.name}
                            label={singleField.label}
                            type={singleField.type}
                            variant="filled"
                            key={singleField.name}
                          />
                        )
                      })
                    }
                  </div>
                ) : (
                  <div className="mb-2" key={field.name}>
                    {
                      field.type !== 'location' ?
                        <Input
                          name={field.name}
                          label={field.label}
                          placeholder={field.placeholder}
                          variant="filled"
                        />
                        :
                        <GooglePlaces
                          name={field.name}
                          label={'Locaton Url'}
                          labelStyle={{ mb: '10px', fontSize: '12px' }}
                          bodyStyle={{ mt: '15px', border: 'none' }}
                          inputStyle={{ marginTop: '15px', padding: '4px', border: 'none', bgcolor: 'red' }}
                          optionStyle={{ margin: "2px 0", padding: '2px', cursor: 'pointer' }}
                          getUrl={(data) => getUrl(data)}
                        />
                    }
                  </div>
                )
              }
            </React.Fragment>
          )
        })
      }
      {/* <Box component={'a'} href={LocationUrl} target='_blank' sx={{ textDecoration: 'none', mb: '12px' }}>{LocationUrl ? 'confirm Link' : "cant't generate link"}</Box> */}
    </Box >
  )
})
